export default __webpack_public_path__ + "static/media/photo--lg--85.cc27f649.jpg";